/*
 * @Author: Lina
 * @Date: 2020-06-22 19:13:22
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-14 13:28:54
 */
import React from 'react';
import PropTypes from 'prop-types';
import './index.scss'
import _ from 'lodash';
import { isLogged, trackClick } from '@/utils/util';
import { Toast } from 'antd-mobile';
import CrgtEvent from '@/components/CrgtEvent'
import { businessType } from '@/utils/constant'
import loading from '@/utils/loading';
import moment from 'moment';


class DiscountCard extends React.Component {
  state = {
    cardImgKey: '',
    prepareCardToken: '',
    isNew: false,
    isObtainCard: false,
    showLoading: false,
    errMsg: '',
    objectiveInfoList: [],
    cardEndTime: '',
    cardState: '',
    primaryTask: {},
    secondTask: {}
  }
  static propTypes = {
    condition: PropTypes.string,
    routerFail: PropTypes.string,
    // notLoggedNewAccountBg: PropTypes.string,
    getCardNewAccountBg: PropTypes.string,
    alreadyGotNewAccountBg: PropTypes.string,
    // notLoggedOldAccountBg: PropTypes.string,
    getCardOldAccountBg: PropTypes.string,
    alreadyGotOldAccountBg: PropTypes.string
  }
  constructor(props) {
    super(props);
    const { condition } = this.props
    this.state = {
      cardImgKey: condition === 'all' || condition === 'isNew' ? 'getCardNewAccountBg' : 'getCardOldAccountBg'
    }
  }
  componentDidMount = () => {

    this.onVisiblityChange()
    document.addEventListener('visibilitychange', this.onVisiblityChange, false)
  }

  componentWillUnmount = () => {
    document.removeEventListener('visibilitychange', this.onVisiblityChange);
  }

  onVisiblityChange = async () => {
    console.log('document hidden', document.hidden)
    if (document.hidden) return;
    const token = await isLogged();
    if (token) {
      this.setState({ showLoading: true, errMsg: '' }, this.fetchCardInfo)
    }
  }

  getCardImg(data) {
    const { condition } = this.props;
    const { isObtainCard } = data;
    switch (condition) {
      case 'isNew': return isObtainCard ? this.getCardStateImg(data) : 'getCardNewAccountBg';
      case 'isOld': return isObtainCard ? this.getCardStateImg(data) : 'getCardOldAccountBg';
      default: break;
    }
  }

  getCardStateImg(data) {
    const { condition } = this.props;
    const { cardState, objectiveInfoList, unfinishedReason } = data;
    const primaryTask = objectiveInfoList && objectiveInfoList.find(item => (item.isMainObjective === true)) || {};
    console.log('data', data)
    const {
      cardOnGoingBg,
      cardFinishedBg,
      cardEarlyQuitBg,
      cardUnFinishedBg } = this.props;

    const alreadyGot = (condition === 'isNew' || condition === 'all') ? 'alreadyGotNewAccountBg' : 'alreadyGotOldAccountBg';
    const cardImgDomMap = new Map([
      ['FINISHED', { func: () => cardFinishedBg ? 'cardFinishedBg' : alreadyGot }],
      ['SETTLING', { func: () => cardFinishedBg ? 'cardFinishedBg' : alreadyGot }],
      ['UNFINISHED', { func: () => { return (unfinishedReason === 'EARLY_QUIT' ? (cardEarlyQuitBg ? 'cardEarlyQuitBg' : alreadyGot) : (cardUnFinishedBg ? 'cardUnFinishedBg' : alreadyGot)) } }],
      ['ONGOING', { func: () => { return ((!primaryTask.isHadCompleted || !cardOnGoingBg) ? alreadyGot : 'cardOnGoingBg') } }],
      ['default', { func: () => { return alreadyGot } }]
    ])

    return cardState ? cardImgDomMap.get(cardState).func() : cardImgDomMap.get('default').func()

  }



  onClickCard = (cardImgKey) => {
    const { primaryTask = {}, errMsg, showLoading } = this.state;
    if (showLoading) return;
    if (errMsg) return Toast.info(<div style={{ padding: "5px" }}>{errMsg}</div>, 4);
    const cardFuncMap = new Map([
      ['alreadyGotNewAccountBg', () => this.onGoRouter(primaryTask.objectiveType)],
      ['alreadyGotOldAccountBg', () => this.onGoRouter(primaryTask.objectiveType)],
      ['getCardNewAccountBg', () => this.getDiscountCard()],
      ['getCardOldAccountBg', () => this.getDiscountCard()],
      ['default', () => { }]
    ])
    return cardFuncMap.get(cardImgKey) ? cardFuncMap.get(cardImgKey)() : undefined
  }

  onGoRouter = (objectiveType = 1) => {
    const params = {
      nativePage: businessType[objectiveType]
    }
    return CrgtEvent.openNativeView(params)
  }

  fetchCardInfo = async () => {
    const { showLoading } = this.state;
    showLoading && loading.show()
    const { condition, routerFail } = this.props;
    const res = await CrgtEvent.getCardInfo();
    // const res = {
    //   code: 0,
    //   data: {
    //     prepareCardToken: '123', isNew: false,
    //     isObtainCard: true,
    //     cardEndTime: '2020-07-26',
    //     cardState: 'ONGOING',
    //     objectiveInfoList: [
    //       {
    //         objectiveType: 8801,
    //         isHadCompleted: true,
    //         unfinishedOrderNum: 1,
    //         isMainObjective: true
    //       },
    //       {
    //         objectiveType: 1,
    //         isHadCompleted: false,
    //         unfinishedOrderNum: 2,
    //         isMainObjective: false
    //       }
    //     ],
    //     unfinishedReason: 'EARLY_QUIT',  //'DUE_TO_QUIT',  //EARLY_QUIT

    //   }
    // }
    if (res.code === 0) {
      const { prepareCardToken, isNew, isObtainCard, cardEndTime, cardState, objectiveInfoList } = res.data;

      this.setState({ showLoading: false })
      loading.hide()
      if (!isObtainCard) {
        if (condition === 'isNew' && !isNew) {
          trackClick('s_status_common_17', { userType: isNew ? 'new' : 'old' })
          this.setState({ errMsg: '此活动限新用户参加，去看看其他活动吧~' })
          return !_.isEmpty(routerFail) ? window.location.replace(routerFail) : Toast.info('此活动限新用户参加，去看看其他活动吧~');
        }
        if (condition === 'isOld' && isNew) {
          trackClick('s_status_common_17', { userType: isNew ? 'new' : 'old' })
          this.setState({ errMsg: '此活动限老用户参加，去看看其他活动吧~' })
          return !_.isEmpty(routerFail) ? window.location.replace(routerFail) : Toast.info('此活动限老用户参加，去看看其他活动吧~');
        }
      }

      // cardState: ONGOING:履约进行中;SETTLING:约定到期核对中;FINISHED:已完成约定;UNFINISHED:未完成约定
      const cardImgKey = this.getCardImg(res.data);
      console.log(cardImgKey, 'cardImg')
      this.setState({
        prepareCardToken: prepareCardToken,
        cardImgKey,
        isNew: isNew,
        isObtainCard: isObtainCard,
        showLoading: false,
        objectiveInfoList,
        cardEndTime,
        cardState,
        primaryTask: objectiveInfoList && objectiveInfoList.find(item => (item.isMainObjective === true)),
        secondTask: objectiveInfoList && objectiveInfoList.find(item => (item.isMainObjective !== true))
      })

    } else {
      console.log('res', res)

      this.setState({ showLoading: false, errMsg: res })
      loading.hide();
    }

  }

  getDiscountCard = async () => {
    const { isObtainCard, prepareCardToken, showLoading, primaryTask } = this.state;
    console.log('state getcard', this.state)
    const token = await isLogged();
    console.log('token', token)
    if (!token) {
      window.crgt.router.openLogin().then((res) => {
        if (res && res.code === 0) {
          window.location.reload();
        }
      });
      return;
    } else {

      if (isObtainCard) {
        return this.onGoRouter(primaryTask.objectiveType);
      };
      if (!prepareCardToken) {
        return Toast.info('暂无对应预受理领卡请求')
      }
      trackClick('c_click_common_87')
      prepareCardToken && CrgtEvent.openDiscountCard(prepareCardToken);
    }

  }

  renderImg(cardImgKey) {
    const { alreadyGotNewAccountBg, alreadyGotOldAccountBg, getCardNewAccountBg, getCardOldAccountBg,
      cardOnGoingBg,
      cardFinishedBg,
      cardEarlyQuitBg,
      cardUnFinishedBg } = this.props;

    const cardImgState = {
      'alreadyGotNewAccountBg': alreadyGotNewAccountBg,
      'alreadyGotOldAccountBg': alreadyGotOldAccountBg,
      'getCardNewAccountBg': getCardNewAccountBg,
      'getCardOldAccountBg': getCardOldAccountBg,
      'cardFinishedBg': cardFinishedBg,
      'cardOnGoingBg': cardOnGoingBg,
      'cardUnFinishedBg': cardUnFinishedBg,
      'cardEarlyQuitBg': cardEarlyQuitBg,
    }
    console.log('props', cardImgState[cardImgKey])
    return <img src={cardImgState[cardImgKey]} alt="" />
  }
  render() {

    const { cardImgKey, primaryTask, cardState, secondTask, cardEndTime } = this.state;

    const diffDay = moment(cardEndTime).diff(moment(), 'd');
    return (<div className="discount-card-container" onClick={() => this.onClickCard(cardImgKey)}>
      {this.renderImg(cardImgKey)}
      {primaryTask && secondTask && primaryTask.isHadCompleted && cardState === 'ONGOING' &&
        <div className="discount-card-ongoing">
          <div>{diffDay <= 0 ? <div>剩余不足<span>1</span>天</div> : <div>剩余<span>{diffDay}</span>天</div>}</div>
          <div>剩余<span>{secondTask.unfinishedOrderNum}</span>单</div>
        </div>}
    </div>)
  }
}
export default DiscountCard;